export { ChipInactive as default } from './ChipInactive';
